module.exports = __webpack_public_path__ + "static/11-11360da8aec4e113611e01ee6180c7d0.jpg";